import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../utils/cn';

const SIZES = { xs: 'w-3 h-3', sm: 'w-4 h-4', md: 'w-5 h-5', lg: 'w-6 h-6', xl: 'w-8 h-8' };

export function Spinner({ size = 'md', label = 'Chargement…', className, ...rest }) {
  return (
    <span role="status" aria-label={label} className={cn('inline-flex items-center justify-center text-mute', className)} {...rest}>
      <Loader2 className={cn('animate-spin', SIZES[size])} strokeWidth={1.8} />
      <span className="sr-only">{label}</span>
    </span>
  );
}

export default Spinner;
